import { handleSkeletonRow, removeSkeletonRow } from "../../../../../entrypoints/vanila/nota_fiscal";
import { store } from '../store';
import { nomeDoEventoDeRecarga } from './eventoDeRecarga';
const associationElBodyTableWithPath = {
  '/nota_fiscals': 'table-body-nfes-emitidas',
}

export const PARAMS_MULTISELECT = ['cfop', 'fornecedor_id', 'tags'];

export const PATHS_LISTAGEM_SPA = ['/processos', '/linha_extrato_bancarios', '/contas_correntes'];

export const PATHS_FILTRO_SEM_HISTORICO = ['/linha_extrato_bancarios'];

export const PARAMS_TEXTO_LIVRE = [
  'descricao',
  'descricao_produto',
  'codigo_produto',
  'nome',
  'numero_documento',
  'numero_nfe',
  'numero_pedido',
  'valor_de',
  'valor_ate',
];

export function ehParamTextoLivre(key) {
  return PARAMS_TEXTO_LIVRE.includes(String(key).replace(/_exact$/, ''));
}

export function normalizarParamsMultiselect(params) {
  PARAMS_MULTISELECT.forEach(nomeParametro => {
    const valorConcatenado = params.get(nomeParametro);
    if (valorConcatenado && valorConcatenado.includes(',')) {
      const valoresIndividuais = valorConcatenado.split(',').map(valorIndividual => valorIndividual.trim());
      params.delete(nomeParametro);
      valoresIndividuais.forEach(valorIndividual => params.append(`${nomeParametro}[]`, valorIndividual));
    }
  });
  return params;
}

export function paramsURL() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const paramsObject = Object.fromEntries(params);
  return {
    url,
    params,
    paramsObject
  };
}

export function aplicaFiltroEmURL(filtro, valor, path) {
  const _el = document.getElementById(associationElBodyTableWithPath[path])

  let valorParsed;
  const { url, params } = paramsURL();
  if (filtro.includes('data')) {
    valorParsed = converteData(valor);
  } else {
    valorParsed = valor;
  }

  const paramsAntesDaAplicacao = params.toString();

  const keyFiltroAdvanced = filtro.replace('_exact', '');
  const advancedSetting = store.state.advancedSettings[keyFiltroAdvanced];
  if (advancedSetting) {
    const removeParam = advancedSetting === 'exact' ? '' : '_exact';
    params.delete(keyFiltroAdvanced+removeParam);
  }

  if (valor === '' || valor == null || (Array.isArray(valor) && valor.length === 0)) {
    params.delete(filtro);
  } else {
    params.set(filtro, valorParsed);
  }
  if (params.toString() !== paramsAntesDaAplicacao) {
    params.delete('page');
  }
  url.search = params.toString();
  if (params.get('limpar_filtro')) {
    params.delete('limpar_filtro');
    url.search = params.toString();
  }
  if (!params.get('filtro_aplicado')) {
    params.set('filtro_aplicado', 'true');
    url.search = params.toString();
  }
  aplicaParametroNoSessionStorage('filtro_aplicado', 'true');
  registraUrlNoHistorico(url, path);
  applyFiltersToListagem(path, _el);
}

export function removeFiltroDaURL(filtro, path) {
  const _el = document.getElementById(associationElBodyTableWithPath[path])

  const { url, params } = paramsURL();
  const base = filtro.replace(/_exact$/, '');
  params.delete(base);
  params.delete(`${base}_exact`);
  params.delete('page');
  url.search = params.toString();
  registraUrlNoHistorico(url, path);
  applyFiltersToListagem(path, _el);
}

export function limparFiltrosDaURL(path, paramsProtegidos = []) {
  const _el = document.getElementById(associationElBodyTableWithPath[path])

  const url = new URL(window.location.href);
  const paramsAnteriores = new URLSearchParams(url.search);
  url.search = '';
  const params = new URLSearchParams(url.search);
  paramsProtegidos.forEach(nome => {
    const valor = paramsAnteriores.get(nome);
    if (valor !== null) params.set(nome, valor);
  });
  params.set('limpar_filtro', 'true');
  url.search = params.toString();
  registraUrlNoHistorico(url, path);
  aplicaParametroNoSessionStorage('filtro_aplicado', 'false');
  applyFiltersToListagem(path, _el);
}

export function capturaFiltrosDaURL() {
  const { params } = paramsURL();
  const filtros = {};
  const arrayFiltro = [];
  for (const [key, value] of params) {
    arrayFiltro.push(key);
    filtros[key] = value;
  }
  return {
    arrayFiltro,
    filtros
  };
}

let applyFiltersTimeout = null;
export function applyFiltersToListagem(path, element, additionalParams = {}) {
  const ehListagemSpa = PATHS_LISTAGEM_SPA.includes(path);

  if (!ehListagemSpa) {
    handleSkeletonRow();
  }

  if (applyFiltersTimeout) {
    clearTimeout(applyFiltersTimeout);
  }

  const ids = coletarIdsSelecionados(element);
  applyFiltersTimeout = setTimeout(() => {
    if (ehListagemSpa) {
      handleLoadingFilters(path, true);
      return;
    }

    try {
      const { paramsObject } = paramsURL();
      const transformedParams = Object.fromEntries(
        Object.entries(paramsObject).map(([key, value]) => {
          if (!ehParamTextoLivre(key) && value && typeof value === 'string' && value.includes(',')) {
            return [key, value.split(',').map(item => item.trim())];
          }
          return [key, value];
        })
      );

      delete transformedParams.format;

      handleLoadingFilters(path, true);

      $.rails.ajax({
        url: path || window.location.pathname,
        type: 'GET',
        dataType: 'script',
        data: {
          ...transformedParams,
          filtro_aplicado: true,
          ids_notas_selecionadas: ids,
          ...additionalParams
        },
        complete: () => {
          handleLoadingFilters(path, false);
        }
      });
    } catch (error) {
      console.error('Erro ao aplicar filtro na listagem', error);
    } finally {
      removeSkeletonRow();
    }
  }, 300);
}

function rotuloDeSelecionados(quantidade) {
  return quantidade === 1 ? '1 selecionado' : `${quantidade} selecionados`;
}

function renderFiltroSelectMultiplo(valores, itens, filterKey) {
  if (valores.length === 0) return;

  const rotulos = valores
    .map(valor => itens.find(item => item.id == valor))
    .filter(Boolean)
    .map(item => item.name);

  filterKey.id = valores;
  filterKey.name = rotulos.length === valores.length
    ? rotulos.join(', ')
    : rotuloDeSelecionados(valores.length);
}

function valoresDoFiltroAplicado(filtroAplicado) {
  return String(filtroAplicado)
    .split(',')
    .map(valor => valor.trim())
    .filter(valor => valor !== '');
}

export function renderFiltroSelect(filtroAplicado, itens, filterKey) {
  if (!filtroAplicado) return;

  const valores = valoresDoFiltroAplicado(filtroAplicado);
  if (valores.length === 0) return;

  if (valores.length > 1) {
    renderFiltroSelectMultiplo(valores, itens, filterKey);
    return;
  }

  itens.forEach(item => {
    if (item.id == valores[0]) {
      filterKey.id = item.id;
      filterKey.name = item.name;
    }
  });
}

export function removeAccents(str) {
  if (typeof str !== 'string') return str;
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function registraUrlNoHistorico(url, path) {
  if (PATHS_FILTRO_SEM_HISTORICO.includes(path)) {
    window.history.replaceState(window.history.state, '', url);
    return;
  }

  window.history.pushState({}, '', url);
}

function aplicaParametroNoSessionStorage(param, value) {
  const sessionStorage = window.sessionStorage;
  if (!sessionStorage.getItem(param)) {
    sessionStorage.setItem(param, value);
  }
}

function converteData(data) {
  if (typeof data !== 'string') return data;

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
    return data;
  }

  if (/^\d{2}-\d{2}-\d{4}$/.test(data)) {
    const [dia, mes, ano] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  return data;
}

function coletarIdsSelecionados(element) {
  if (!element) return [];
  
  const ids = [];
  element.querySelectorAll('input[type="checkbox"]:checked').forEach(item => {
    ids.push(item.value);
  });
  return ids;
}

function handleLoadingFilters(eventName, isLoading) {
  document.dispatchEvent(new CustomEvent(nomeDoEventoDeRecarga(eventName), { detail: isLoading }));
}
